import Box from "ds/components/Box";
import Badge from "ds/components/Badge";

import { CellComponentProps } from "../../types";

type PermissionsListItemSubjectCellProps = CellComponentProps;

const PermissionsListSubjectNameCell = ({ permission }: PermissionsListItemSubjectCellProps) => {
  return (
    <Box fullWidth>
      <Badge type="strong" variant="gray" text={permission.subject} />
    </Box>
  );
};

export default PermissionsListSubjectNameCell;
